import { dayjsUTC } from "@/helpers/dateHelper"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { WarrantsAccount } from "@/models/admin/warrantsAccount/warrantsAccount"
import {
  IWarrantsAccount,
  WarrantsAccountState,
} from "@/models/admin/warrantsAccount/warrantsAccount.types"

/**
 * A single `warrants_accounts` row as returned by Hasura. Mirrors the generated
 * `Financials_Warrants_Accounts` row; kept as a narrow type so the parser only
 * depends on the columns it actually reads.
 */
export type WarrantsAccountRaw = {
  id: number
  account_number: string
  status: string
  pause_start?: string | null
  created_at: string
  deleted_at?: string | null
  deleted_by_agent_email?: string | null
}

export const WarrantsAccountParser: IParser<
  IWarrantsAccount,
  WarrantsAccountRaw
> = {
  toDomain(data) {
    try {
      // Hasura `timestamp`/`date` columns are naive UTC, so parse them as UTC
      // and convert to local time for display.
      return new WarrantsAccount(
        data.id,
        data.account_number,
        data.status as WarrantsAccountState,
        data.pause_start ? dayjsUTC(data.pause_start) : null,
        dayjsUTC(data.created_at),
        data.deleted_at ? dayjsUTC(data.deleted_at) : null,
        data.deleted_by_agent_email ?? null,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
